import moment from "moment";
import { Avatar, Box, Card, CardContent, Typography } from "@material-ui/core";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";

const AccountProfile = props => {
  const { user = "" } = useAuth();
  const [userObj, setUserObj] = useState({});
  useEffect(() => {
    if (user && typeof user === "string") {
      const cloneUser = jwtDecode(user);
      setUserObj(cloneUser);
    } else if (user && typeof user === "object") {
      setUserObj(user);
    }
  }, [user]);
  return (
    <Card {...props}>
      <CardContent>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Avatar
            sx={{
              height: 100,
              width: 100
            }}
          >
            {userObj?.userName?.slice(0, 2).toUpperCase()}
          </Avatar>
          <Typography color="textPrimary" gutterBottom variant="h3">
            {userObj?.userName}
          </Typography>
          <Typography color="textSecondary" variant="body1">
            {`${userObj?.role}`}
          </Typography>
          <Typography color="textSecondary" variant="body1">
            {`${moment().format("hh:mm A")}`}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AccountProfile;
